<template>
  <v-text-field
    outlined
    v-bind="$attrs"
    type="text"
    :rules="rules"
    :value="newValue"
    id="addressAutocomplete"
    @blur="submitInput($event.currentTarget._value)">
  </v-text-field>
</template>

<script>
export default {
  name: 'EsAddressInput',
  props: {
    value: String,
    required: Boolean,
  },
  data: () => ({
    autocomplete: null,
    newValue: null,
    isValidAddress: false,
    requiredRule: (v) => !!v || 'Required',
  }),
  computed: {
    rules() {
      const rules = [];
      if (this.required) {
        rules.push(this.requiredRule);
      }
      return rules;
    },
  },
  async mounted() {
    if (this.value) {
      this.newValue = this.value;
    }
    this.autocomplete = await this.initiateGoogle();
    if (this.$attrs.label) {
      setTimeout(() => {
        document.getElementById('addressAutocomplete').placeholder='';
      }, 0);
    }
  },
  methods: {
    initiateGoogle() {
      const autocomplete = new window.google.maps.places.Autocomplete(document.getElementById('addressAutocomplete'));
      autocomplete.setComponentRestrictions({  
        'country': ['us', 'pr', 'vi', 'gu', 'mp'],
      });
      autocomplete.setFields([
        'formatted_address',
        // 'geometry.location',
        'place_id',
      ]);
      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        this.submitInput(place.formatted_address);
      });
      return autocomplete;
    },
    submitInput(value) {
      this.newValue = value;
      this.$emit('input', value);
    },
  },
};
</script>
